import { FilterSelection, FiltersInPricesValues, PricesFilterType } from '@/scopes/prices/domain/filters/types'
import { PriceTableAnalyticsWithBrand } from '@/scopes/prices/domain/types'
import * as React from 'react'

interface InitPricesParams {
  accoId: string
  contextItemId: string
  bookingGateId: string
  analytics: PriceTableAnalyticsWithBrand | null
  initialFilterSelection: FilterSelection
  promotedPriceId: string
  priceTableByWeeks: boolean
}

interface ResetPricesParams {
  initialFilterSelection: FilterSelection
}

interface SelectFilterParams {
  type: PricesFilterType
  selection: FiltersInPricesValues
}

interface SelectRangeParams {
  dateFrom: string
  dateTo: string
  month: string
}

interface PricesUseCasesContextType {
  initPrices: (params: InitPricesParams) => Promise<void>
  initPriceTable: (byWeeks?: boolean) => Promise<void>
  selectFilterMonth: (month: string, callback: (startDate: Date) => void) => Promise<void>
  selectFilter: (params: SelectFilterParams) => Promise<void>
  selectRange: (params: SelectRangeParams) => Promise<{ minDatePrices: string, maxDatePrices: string }>
  selectPrice: (priceId: string | null) => Promise<void>
  selectRoom: (roomNumber: string, roomId: string | null) => Promise<void>
  setOutboundRouteId: (routeId: string | null) => Promise<void>
  setInboundRouteId: (routeId: string | null) => Promise<void>
  resetPrices: (params: ResetPricesParams) => Promise<void>
}

export const PricesUseCasesContext = React.createContext<PricesUseCasesContextType>({
  initPrices: async () => {},
  initPriceTable: async () => {},
  selectFilterMonth: async () => {},
  selectFilter: async () => {},
  selectRange: async () => ({ minDatePrices: '', maxDatePrices: '' }),
  selectPrice: async () => {},
  selectRoom: async () => {},
  setOutboundRouteId: async () => {},
  setInboundRouteId: async () => {},
  resetPrices: async () => {},
})
